import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PetResidenceStatus } from 'src/app/interfaces/pet';

@Component({
  selector: 'app-pet-missing-modal',
  templateUrl: './pet-missing-modal.component.html',
  styleUrls: ['./pet-missing-modal.component.scss']
})
export class PetMissingModalComponent implements OnInit {
  @Input() petName: string;

  statuses: any[] = [
    {
      name: 'Lost',
      value: PetResidenceStatus.Lost
    },
    {
      name: 'Stolen',
      value: PetResidenceStatus.Stolen
    }
  ];
  selected = PetResidenceStatus.Lost;

  constructor(public activeModal: NgbActiveModal) { }

  submit(): void {
    this.activeModal.close(this.selected);
  }

  ngOnInit(): void {
  }

}
